import { useContext, useEffect, useState } from "react";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";
import { api } from "../../services/api";
import ListUsers from "../listUser";

export default function ListUserByGroup({ id }) {
    const [users, setUsers] = useState([]);
    const { handleToast, handleLoading } = useContext(GlobalAlertContext);


    useEffect(() => {
        getUsers();
    }, []);

    async function getUsers() {

        handleLoading(true);
        try {
            const { data: users } = await api({ method: "GET", url: "/user/group/" + id });
            setUsers(users)
        } catch (err) {
            handleToast(true, err.response.data.toast, err.response.data.message);
        }
        handleLoading(false);
    }

    return (
        <ListUsers users={users} handleStatusParent={() => getUsers()} ></ListUsers>
    )
}